import React from "react";
import '../Css/Values.css';

const ValueAwareness = () => {
  return (
    <div className="awareness-container">
      <h2 className="awareness-title">
        <span className="gray">VALUE</span>{" "}
        <span className="green">AWARENESS</span>
        <div className="underline" />
      </h2>

      <p className="awareness-description">
        Putting the seed of values in the life of the students by kindling
        interest in the values through life changing and basic value based
        seminars.
      </p>

      <div className="awareness-content">
        <div className="awareness-list">
          <h3>Values Awareness Phase Topics</h3>
          <ul>
            <li>Tree of Life—the Ice burg of success</li>
            <li>The Pencil Parable</li>
            <li>Life’s Amazing Secrets - 10 Golden Keys</li>
            <li>Decoding Success</li>
            <li>Playing the Master Strokes of Life</li>
            <li>Life on Two Wheels</li>
            <li>Selfie Reclicked</li>
            <li>Secrets of Life Balance</li>
            <li>Life Lessons from Titanic</li>
            <li>Mera Bharat Mahan</li>
            <li>Art of Thinking Win Win</li>
            <li>Peace of Mind or Pieces of Mind</li>
            <li>Getting More Done in Less Time</li>
            <li>Winning the Game of Life</li>
            <li>Engineering a Better World</li>
            <li>Love - The Ultimate Reality</li>
          </ul>
        </div>
        <div className="awareness-image">
          <img src = '/assets/edu-training/value-aweour.png' alt="Value Awareness" />
        </div>
      </div>
    </div>
  );
};

export default ValueAwareness;
